// extracted by mini-css-extract-plugin
export default {"container":"AddDrinkPage_container__rhwGV","followTitle":"AddDrinkPage_followTitle__1SGf1","followContainer":"AddDrinkPage_followContainer__TqvNN","box":"AddDrinkPage_box__vzsvN"};